import React, { Component } from 'react'
import { checkTranslation, imageAddress, translate } from '../../../../utils/useful'
import FixedView from '../../../FixedView'
import SwitchInput from '../../../inputs/SwitchInput'
import SidebarView from '../../../SidebarView'
import Members from '../sideBar/Members'
import StagesManager from '../../../StagesManager'
import * as actions from '../../../../stores/actionsList';

import SwitchStyle1 from '../../../useful/SwitchButton'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import ButtonAnimated from '../../../buttons/ButtonAnimated'


class SupportInfoFirst extends Component {
    state = {
        showCollapse: null,
        active: false,
        selected: 0,
        checkBox: {},
        show: false,
        option: [
            // { icon: "/assets/icons/manage-gray.svg", title: "Edit Contact", color: "#444", key: "manage" },
            // { icon: "/assets/icons/messenger/share-contact.svg", title: "Share Contact", color: "#444", key: "share" },
            { icon: "/assets/icons/messenger/block.svg", title: "{{lang}}messenger.Block User", color: "#E61515", key: "block" },
        ],
        supportInfo: {},
        userinfo: { username: "@Gedrich98", des: "this is a test bio description that's it the rest is just a usless words just to make this test a little bit longer for testing the UI.", number: "+989021377118" },
        mediaNum: 0
    }

    componentDidMount() {
        let media = this.props.media
        let mediaNum = this.state.mediaNum
        if (media) {

            Object.values(media)?.forEach(el => {
                if (el.length > 0) {
                    mediaNum = mediaNum + 1
                }
            });
        }
        this.setState({ mediaNum })
        this.setState({ supportInfo: this.props.supportInfo })
    }

    openFirstView = () => {
        this.firstView.showView()
    }

    handleCopy = (item) => {
        navigator.clipboard.writeText(item);
        this.props.actions.addNotif({ type: 'success', title: 'Successfuly Copied!', description: 'Information Successfuly Copied.' })
        // alert('Copied to clipboard!');
    }

    translateStatus = (status) => {
        let newStatus
        switch (status) {
            case 0:
                newStatus = 'not active'
                break;

            case 1:
                newStatus = 'pending'
                break;

            case 2:
                newStatus = 'waiting for awnser'
                break;

            case 3:
                newStatus = 'awnsered'
                break;

            case 4:
                newStatus = 'done'
                break;

            default:
                break;
        }
        return newStatus
    }

    translatePhoneNumber = (num) => {
        let numberChanged = String(num)
        numberChanged = numberChanged.slice(2, numberChanged.length - 1)
        numberChanged = '+' + numberChanged
        return numberChanged
    }


    render() {
        return (
            <div className='h-100 w-100'>
                <div className='flexcb py-3 px-3' style={{ height: '60px', borderBottom: "1px solid #eee", zIndex: 10 }} ref={el => this.firstCurrentNode = el}>
                    <p className='text-bold text-small' style={{}}>{translate('messenger.User Info')}</p>
                    {/* <button ref={el => this.firstCurrentNode = el} onClick={() => this.openFirstView()}>
                            <img width={25} src='/assets/icons/more-v-black.svg' />
                        </button> */}
                </div>
                {/* <FixedView ref={el => this.firstView = el} nodeRef={this.firstCurrentNode} showFocus={false} topOffset={0} xOffset={90} zIndex={10} >
                        <div className='shadow-2 px-3 py-1 br-10' style={{ backgroundColor: "#fff", width: "max-Content" }}>
                            {this.state.option.map((prop, index) => {
                                return (
                                    <div className='my-2'>
                                        <button className='flexc' onClick={() => this.props.changeStage(prop.key)}>
                                            <img src={prop.icon} />
                                            <p className='mld-3' style={{ color: prop.color }}>{prop.title}</p>
                                        </button>
                                    </div>
                                )
                            })}
                        </div>
                    </FixedView> */}
                <div className='scroll-no-scrollbar w-100' style={{ height: 'calc(100% - 60px)' }}>
                    <div className='flexc px-3 py-2' style={{ borderBottom: "1px solid #eee" }}>
                        <img className='br-50' width={50} height={50} style={{ objectFit: "cover" }} src={imageAddress(this.state.supportInfo?.image, 'profile')} />
                        <div className='mld-4'>
                            <p className='font-size-16 weight-600 main-c4' style={{}}>{checkTranslation(this.state.supportInfo?.fullname)}</p>
                            <p className='font-size-12 weight-300 main-c7' style={{}}>{translate('messenger.Last Seen Status')}</p>
                        </div>
                    </div>
                    <div className='flexcb w-100 px-2 py-2' style={{ borderBottom: "1px solid #eee" }}>
                        <div className='flexcb w-100 px-2 py-2 hover-gray br-5'>
                            <div className='flexc'>
                                <img width={22} className='flexcc' src='/assets/icons/messenger/notification-blue.svg' />
                                <p className='mld-3 font-size-14' style={{ color: "#444" }}>{translate('messenger.Notification')}</p>
                            </div>
                            <button className='flexcc'>
                                <SwitchStyle1 />
                            </button>
                        </div>
                    </div>
                    {console.log('esdfvrdgvdfgrfg', this.props)}
                    {this.props.applet?.settings?.type == 'support' && (
                        <div className='d-flex flex-column'>
                            {this.props.messenger && this.props.messenger.assignee &&
                                <div className="flexc px-3 py-2">
                                    <p className="font-size-13 main-c2 weight-400">{translate('Assignee')}:&nbsp;</p>
                                    <p className="font-size-14 main-c2 weight-500">{this.props.messenger?.assignee?.hub?.fullname}</p>
                                </div>
                            }
                            <div className="flexc px-3 pt-2">
                                <p className="font-size-13 main-c2 weight-400">{translate('Status')} :&nbsp;</p>
                                <p className="font-size-14 main-c2 weight-500">{this.translateStatus(this.props.messenger.status)}</p>
                            </div>
                        </div>
                    )}
                    {this.state.mediaNum > 0 &&
                        <div className='py-2 px-2' style={{ borderBottom: "1px solid #eee" }}>
                            <div className='px-2 py-2 br-5 hover-gray' >
                                <button className='flexcb w-100' onClick={() => this.props.changeStage('media')}>
                                    <div className='flexc'>
                                        <img width={22} className='flexcc' src='/assets/icons/messenger/media-blue.svg' />
                                        <p className='mld-3 font-size-14' style={{ color: "#444" }}>{translate('messenger.Media')}</p>
                                    </div>
                                    <div className='flexcc'>
                                        <img width={22} className='rtl-button' src='/assets/icons/arrow-right-blue.svg' />
                                    </div>
                                </button>
                            </div>
                        </div>
                    }
                    <div className='px-2 py-4'>
                        <div className='d-flex flex-column w-100'>
                            <div className='position-relative'>
                                <div className='text-start blue-box-border2 br-10 w-100 flexcb'>
                                    <p className='font-size-14 w-100 px-3 py-3' style={{ color: "#444" }}>{checkTranslation(this.state.supportInfo?.username)}</p>
                                    <button className='mrd-3' onClick={() => this.handleCopy(this.state.supportInfo?.username)}>
                                        <img width={22} className='curser-pointer flexcc' src='/assets/icons/copy-black.svg' />
                                    </button>
                                </div>
                                <div className='br-10 position-absolute' style={{ backgroundColor: "#fff", width: "max-content", top: -7, left: 8 }}>
                                    <p className='font-size-10 weight-300 px-2' style={{ color: "#777" }} >{translate('messenger.Username')}</p>
                                </div>
                            </div>

                            {this.state.supportInfo?.phone && (
                                <div className='position-relative mt-3'>
                                    <div className='text-start blue-box-border2 br-10 w-100 flexcb'>
                                        <p className='font-size-14 w-100 px-3 py-3' style={{ color: "#444" }}>{this.translatePhoneNumber(this.state.supportInfo?.phone)}</p>
                                        <button className='mrd-3' onClick={() => this.handleCopy(this.state.supportInfo?.phone)}>
                                            <img width={22} className='curser-pointer flexcc' src='/assets/icons/copy-black.svg' />
                                        </button>
                                    </div>
                                    <div className='br-10 position-absolute' style={{ backgroundColor: "#fff", width: "max-content", top: -7, left: 8 }}>
                                        <p className='font-size-10 weight-300 px-2' style={{ color: "#777" }} >{translate('messenger.Phone Number')}</p>
                                    </div>
                                </div>
                            )}

                            {/* <button className='text-start mt-4'>
                                    <p className='font-size-14 '>{this.props.messenger.des}</p>
                                </button>
                                <p className='font-size-12' style={{ color: "#777" }}>Bio</p> */}

                        </div>
                    </div>
                    <div className='px-2 py-2 w-100'>
                        <div className='flexcc flex-column w-100'>
                            <div className='pb-1 w-100'>
                                <ButtonAnimated
                                    iconwidth='24px'
                                    // onClick={() => this.createGroup()}
                                    title={translate('End conversation')}
                                    icon='/assets/icons/angle-right-white2.svg'
                                    isLoading={this.props.isLoading}
                                    textColor={'#fff'}
                                    bg={this.props.colors ? this.props.colors.background : ' linear-gradient(90deg, #0085ff, #0085ff)'}
                                    width={'100%'}
                                />
                            </div>
                            <div className='pt-1 w-100'>
                                <ButtonAnimated
                                    iconwidth='24px'
                                    // onClick={() => this.createGroup()}
                                    title={translate('messenger.Block User')}
                                    icon='/assets/icons/block-white.svg'
                                    isLoading={this.props.isLoading}
                                    textColor={'#fff'}
                                    bg={'linear-gradient(90deg, #ff3a30, #ff3a30)'}
                                    width={'100%'}
                                />
                            </div>
                        </div>
                    </div>
                    {/* <div className='px-2 py-2 flexcc' style={{}}>
                        <button className='flexcc w-100 py-2 br-10 cancel-btn2'>
                            <img width={22} className='flexcc' src='/assets/icons/block-white.svg' />
                            <p className='mld-3 font-size-14' style={{ color: "#fff" }}>{translate('messenger.Block User')}</p>
                        </button>
                    </div> */}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SupportInfoFirst);
